import { Component, ViewChild } from '@angular/core';
import { DashboardService } from '../../../../../service/events/dashboard.service';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseForm } from '../../../../base-form';
import { VentasApiService } from '../../../../../service/api/ventas-api.service';
import { RequestButtonComponent } from 'src/app/common/components/request-button/request-button.component';
import { environment } from 'src/environments/environment';

import type { OnInit } from '@angular/core';
import { Compradores } from 'src/app/models/ventas/compradores.model';
import { ReactiveFormBuilderComponent } from 'src/app/common/components/reactive-form-builder/form-builder.component';
import { CompradoresFormDefinition } from './form-definition';
import { Subject } from 'rxjs';
import { EventPhase, FormPhase, FormRequestTypes } from 'src/app/common/components/reactive-form-builder/form-request';
import { HttpClient } from '@angular/common/http';

@Component({
    selector: 'app-compradores-form',
    standalone: false,
    templateUrl: './compradores-form.component.html',
    styleUrls: ['./compradores-form.component.scss']
})
export class CompradoresFormComponent extends BaseForm<Compradores> implements OnInit {

    @ViewChild(RequestButtonComponent, { read: RequestButtonComponent, static: true })
    requestButton = new RequestButtonComponent<Compradores>();

    @ViewChild(ReactiveFormBuilderComponent) formBuilder!: ReactiveFormBuilderComponent<Compradores>;

    public dropdownsFinalized = false;

    public form!: CompradoresFormDefinition;

    public formRequest = new ReactiveFormBuilderComponent(this.http);

    /** Emits when dropdowns are ready to be reloaded */
    public readonly dropdownLoadTrigger = new Subject<void>();

    public readonly FormRequestTypes = FormRequestTypes;

    public override model: Compradores = {} as Compradores;


    constructor(public override dashboard: DashboardService,
        public override router: Router,
        public override route: ActivatedRoute,
        public ventasApi: VentasApiService,
        private readonly http: HttpClient
    ) {
        super(
            route,
            router,
            dashboard,
            ventasApi.compradoresPUT,
            ventasApi.compradoresPOST,
            'compradores',
            'Actualizar ' + environment.features.comercioName,
            'Crear ' + environment.features.comercioName
        );

                this.form = new CompradoresFormDefinition(
                    this.getType(),
                    this.getModel() as unknown as Record<string, string>,
                    null
                );
    }

    ngOnInit() {
        this.formRequest.addEvent(FormPhase.LOAD, EventPhase.AFTER, (resolve) => {
            this.form.lists.tipos.selected = 'Proveedor';
            this.form.model.tipo = 'Proveedor';
            resolve(true);
        });

        this.softInit(this.getType());
    }

    public formChanges(formModel: [object, string], _tag: string) {
        this.form.model = formModel as unknown as Compradores;
    }// ();
}// class;
